/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deviceHealthResponseSchema = z.object({
	is_ok: z.boolean(),
	menu_last_time_updated: z.iso.datetime(),
});
